var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50,50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.7)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#8e9581",
    r: 50,
    cy: 0,
    cx: 0,
    stroke: "#FFFFFFA0",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#526035",
    r: 15,
    cy: -28,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    values: "0 0 0;360 0 0",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    dur: "1.0101010101010102s",
    type: "rotate",
    attributeName: "transform"
  })))), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.a522d857c441eb944bbe475d52661b00.svg";
export { ForwardRef as ReactComponent };